// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3gDQc","requiredAsterisk":"Info_requiredAsterisk__2sDPu"};